import React from "react";
import horizontalSplit from "./utils/horizontalSplit";
import splitArray from "./utils/splitArray";
import { SearchHit } from "../../../../creditSearch";
import { clampColumnWidthPct } from "../../../../utils/maxColumnWidth";

const balanceAlignment = (alignment, columns) => {
  switch (alignment) {
    case "left":
      if (columns === 1) {
        if (alignment === "left") {
          return [" justify-start items-start text-left "];
        }
        // else{return [" justify-center items-center text-center"];}
      } else if (columns === 2) {
        return [" items-start ", " items-start "];
      }
      break;
    case "right":
      if (columns === 1) {
        return [" d-block justify-end items-end text-right"];
      } else if (columns === 2) {
        return [" items-end ", " items-end "];
      }
      break;
    case "justify":
      if (columns === 1) {
        return ["justify-start items-center "];
      } else if (columns === 2) {
        return [" items-start ", " items-end "];
      }
      break;
    case "center":
      if (columns === 1) {
        return [" justify-center items-center "];
      } else if (columns === 2) {
        return [" center ", " center "];
      }
      break;
    default:
      if (columns === 1) {
        return [" items-center "];
      } else if (columns === 2) {
        return [" items-end ", " items-start "];
      }
  }
};

const display = (
  options,
  index,
  idx,
  index1,
  index3_1,
  index3_2,
  filterItems
) => {
  if (options.balance_columns) {
    if (options.columns === 2 && filterItems.length === 1) {
      if (index === 1 && idx === index1) {
        return true;
      } else {
        return false;
      }
    } else if (options.columns === 3 && filterItems.length === 2) {
      if (index === 0 && idx === index3_1) {
        return true;
      } else if (index === 1 && idx === index3_2) {
        return true;
      } else {
        return false;
      }
    } else if (options.columns === 3 && filterItems.length === 1) {
      return false;
    }
  } else {
    return false;
  }
};

const getAlignment = (text_alignment, columns) => {
  switch (text_alignment) {
    case "left":
      if (columns === 1) {
        return [" items-center ", " text-red-600 "];
      } else if (columns === 2) {
        return [" items-start text-start ", " items-start text-start "];
      } else if (columns === 3)
        return [
          " items-start text-start",
          " items-start text-start ",
          " items-start text-start",
        ];
      else if (columns === 4) {
        return [
          " items-start text-start",
          " items-start text-start",
          " items-start text-start",
          " items-start text-start",
        ];
      } else {
        return [
          " items-start ",
          " items-start ",
          " items-start ",
          " items-start ",
          " items-start ",
        ];
      }

    case "justify":
      if (columns === 1) {
        return [" items-center "];
      } else if (columns === 2) {
        return [" items-start text-start", " items-end text-end "];
      } else if (columns === 3)
        return [
          " items-start text-start",
          " items-center ",
          " items-end text-end",
        ];
      else if (columns === 4) {
        return [
          " items-start text-start",
          " items-start text-start",
          " items-end text-start",
          " items-end text-start",
        ];
      } else {
        return [
          " items-start ",
          " items-start ",
          " items-center ",
          " items-end ",
          " items-end ",
        ];
      }

    case "right":
      if (columns === 1) {
        return [" items-center "];
      } else if (columns === 2) {
        return [" items-end text-end ", " items-end text-end"];
      } else if (columns === 3)
        return [
          " items-end text-end",
          " items-end text-end",
          " items-end text-end",
        ];
      else if (columns === 4) {
        return [
          " items-end text-end",
          " items-end text-end",
          " items-end text-end",
          " items-end  text-end",
        ];
      } else {
        return [
          " items-end ",
          " items-end ",
          " items-end ",
          " items-end ",
          " items-end ",
        ];
      }

    case "center":
      if (columns === 1) {
        return [" items-center "];
      } else if (columns === 2) {
        return [" items-center ", " items-center "];
      } else if (columns === 3)
        return [" items-center ", " items-center ", " items-center "];
      else if (columns === 4) {
        return [
          " items-center ",
          " items-center ",
          " items-center ",
          " items-center ",
        ];
      } else {
        return [
          " items-center ",
          " items-center ",
          " items-center ",
          " items-center ",
          " items-center ",
        ];
      }
    default:
      if (columns === 1) {
        return [" items-center "];
      } else if (columns === 2) {
        return [" items-end text-end", " items-start text-start"];
      } else if (columns === 3)
        return [
          " items-end text-end ",
          " items-center ",
          " items-start text-start ",
        ];
      else if (columns === 4) {
        return [
          " items-end ",
          " items-center ",
          " items-center ",
          " items-start ",
        ];
      } else {
        return [
          " items-end ",
          " items-end ",
          " items-center ",
          " items-start ",
          " items-start ",
        ];
      }
  }
};

const getNewSplitData = (filterItems, splitArray) => {
  let newData = [...splitArray];
  if (filterItems.length === 2) {
    newData[0].push(filterItems[0]);
    newData[2].push(filterItems[1]);
  }
  return newData;
};

export default function Song2({ options, items, fontStyle, idx, settings }) {
  const newItems = [];
  items.map((itm) => {
    if (itm.song) newItems.push(itm);
  });
  items = newItems;

  const [...itemsCopy] = items;

  const sortedItems =
    options.column_order === null
      ? itemsCopy
      : options.column_order === "ascending"
      ? itemsCopy.sort((a, b) => a?.song?.title?.localeCompare(b?.song?.title))
      : itemsCopy.sort((a, b) => b?.song?.title?.localeCompare(a?.song?.title));

  const { ans: arraySplitData1, indexMap } =
    options.column_flow === "vertical"
      ? splitArray(sortedItems, options)
      : horizontalSplit(sortedItems, options);

  const extraItems = arraySplitData1.map((items, idx) => {
    if (indexMap[idx + 1] === true) {
      return items[items.length - 1];
    }
  });

  const filterItems = extraItems.filter((item) => {
    return item;
  });

  const rowendLines = (horizontal_gap, idx) => {
    if (horizontal_gap !== "") {
      return (
        <div id={idx + "row_endlines"}>
          {[...Array(horizontal_gap)].map((e, i) => (
            <div style={{ height: "10px" }} />
          ))}
        </div>
      );
    } else {
      return <div id={idx + "row_endlines"}></div>;
    }
  };

  const index1 = arraySplitData1[1]?.length - 1;
  const index3_1 = arraySplitData1[0]?.length - 1;
  const index3_2 = arraySplitData1[1]?.length - 1;
  const textAlignment = getAlignment(options.text_alignment, options.columns);

  const arraySplitData =
    filterItems.length === 2 && options.balance_columns === "center"
      ? getNewSplitData(filterItems, arraySplitData1)
      : arraySplitData1;

  const columnCount = Math.max(1, Number(options.columns) || 1);
  const columnWidthPct = clampColumnWidthPct(
    options.column_width,
    columnCount,
  );
  const totalWidthPct = Math.min(columnWidthPct * columnCount, 100);
  const colWidth = `${100 / columnCount}%`;

  const getLines = (lines) => {
    const linesArr = [];
    // console.log(lines);
    for (let i = 0; lines !== undefined && i < lines.length; i++) {
      linesArr.push(
        <p
          className="FontSIzeScale"
          style={{
            ...fontStyle.songDetails,
            lineHeight: fontStyle?.songDetails?.lineHeight + 0.2,
            fontKerning: "none",
            fontFeatureSettings: '"kern" 0',
            textRendering: "geometricPrecision",
            WebkitFontSmoothing: "antialiased",
          }}
        >
          {lines[i] ? <SearchHit text={lines[i]} /> : lines[i]}
        </p>
      );
    }
    return linesArr;
  };

  return (
    <>
      <table
        className="songColumnsRow"
        style={{
          width: `${totalWidthPct}%`,
          margin: "0 auto",
          tableLayout: "fixed",
          borderCollapse: "collapse",
          wordBreak: "break-word",
        }}
      >
        <tbody>
          <tr>
        {arraySplitData?.map((items, index) => (
          <td
            key={index}
            className={`align-top ${textAlignment[index]}`}
            style={{
              width: colWidth,
              verticalAlign: "top",
              border: "none",
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft:
                arraySplitData.length >= 2 &&
                index !== 0 &&
                options.text_alignment === "gutter"
                  ? `${settings.gutter}px`
                  : 0,
              paddingRight:
                arraySplitData.length >= 2 &&
                index !== 1 &&
                options.text_alignment === "gutter"
                  ? `${settings.gutter}px`
                  : 0,
            }}
          >
          <div className={`flex flex-col ${textAlignment[index]}`}>
            {items?.map((item, idx) => {
              const lines = item?.song?.details?.trim()?.split("\n");
              return display(
                options,
                index,
                idx,
                index1,
                index3_1,
                index3_2,
                filterItems
              ) ? (
                <></>
              ) : (
                <>
                  <p
                    className="FontSIzeScale"
                    style={{
                      ...fontStyle.songTitle,
                      lineHeight: fontStyle?.songTitle?.lineHeight + 0.23,
                      fontKerning: "none",
                      fontFeatureSettings: '"kern" 0',
                      textRendering: "geometricPrecision",
                      WebkitFontSmoothing: "antialiased",
                    }}
                  >
                    {item ? <SearchHit text={item?.song?.title} /> : ""}
                  </p>
                  {getLines(lines)}

                  {/* {rowendLines(options.horizontal_gap, idx)} */}
                  <div style={{ height: `${options?.horizontal_gap}px` }} />
                </>
              );
            })}
          </div>
          </td>
        ))}
          </tr>
        </tbody>
      </table>
      {options.balance_columns ? (
        <div
          className={`flex flex-row justify-center ${
            filterItems.length === 2 && " "
          } ${balanceAlignment(options.text_alignment, 1)[0]}`}
          style={{
            width: `${totalWidthPct}%`,
            margin: "auto",
          }}
        >
          {filterItems.length === 1 &&
            options?.columns === 2 &&
            filterItems?.map((item, index) => {
              const lines = item?.song?.details?.trim()?.split("\n");
              const line1 = lines[0];
              const line2 = lines[1];
              const line3 = lines[2];
              const line4 = lines[3];
              // const line1 = item.song.details.split("Performed")[0];
              // const line2 = item.song.details
              //   .split("Performed by")[1]
              //   .split("Courtesy")[0];
              // const line3 = item.song.details
              //   .split("Courtesy of")[1]
              //   .split("By")[0];
              // // const line4 = item.song.details.split(
              // //   "By arrangement with Distributor"
              // // )
              // const line04 = item.song.details.split("By arrangement with Distributor")[1]?.trim();
              // const line4 = line04 ? "By arrangement with Distributor" + " " + line04 : "By arrangement with Distributor"
              // [1];
              return (
                <>
                  <div
                    className={`flex flex-col ${
                      options.text_alignment === " right " ? " " : " flex-1 "
                    } ${balanceAlignment(options.text_alignment, 1)[0]} `}
                    // className={`flex flex-col ${textAlignment[0]}`}
                  >
                    <>
                      <p
                        className="FontSIzeScale"
                        style={{
                          ...fontStyle.songTitle,
                          fontKerning: "none",
                          fontFeatureSettings: '"kern" 0',
                          textRendering: "geometricPrecision",
                          WebkitFontSmoothing: "antialiased",
                        }}
                      >
                        {item ? <SearchHit text={item?.song?.title} /> : ""}
                      </p>

                      <p
                        className="FontSIzeScale"
                        style={{
                          ...fontStyle.songDetails,
                          fontKerning: "none",
                          fontFeatureSettings: '"kern" 0',
                          textRendering: "geometricPrecision",
                          WebkitFontSmoothing: "antialiased",
                        }}
                      >
                        {line1 ? <SearchHit text={line1} /> : line1}
                      </p>

                      <p
                        className="FontSIzeScale"
                        style={{
                          ...fontStyle.songDetails,
                          fontKerning: "none",
                          fontFeatureSettings: '"kern" 0',
                          textRendering: "geometricPrecision",
                          WebkitFontSmoothing: "antialiased",
                        }}
                      >
                        {line2 ? <SearchHit text={line2} /> : line2}
                      </p>

                      <p
                        className="FontSIzeScale"
                        style={{
                          ...fontStyle.songDetails,
                          fontKerning: "none",
                          fontFeatureSettings: '"kern" 0',
                          textRendering: "geometricPrecision",
                          WebkitFontSmoothing: "antialiased",
                        }}
                      >
                        {line3 ? <SearchHit text={line3} /> : line3}
                      </p>

                      <p
                        className="FontSIzeScale"
                        style={{
                          ...fontStyle.songDetails,
                          fontKerning: "none",
                          fontFeatureSettings: '"kern" 0',
                          textRendering: "geometricPrecision",
                          WebkitFontSmoothing: "antialiased",
                        }}
                      >
                        {line4 ? <SearchHit text={line4} /> : line4}
                      </p>
                      {/* {rowendLines(options.horizontal_gap, idx)} */}
                    </>
                  </div>
                  {(options?.text_alignment === "left" ||
                    options?.text_alignment === "right") && (
                    <div className="flex-1"></div>
                  )}
                </>
              );
            })}
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
